import * as React from "react";
import * as d3 from "d3";
import ReactTooltip from 'react-tooltip'

const InnerPath = props => {
    let { pie, width, height, radius, innerRadius,maxValue } = props;

    let arc = d3.arc()
        .innerRadius(innerRadius)
        .outerRadius(function (d) {
            return (radius - innerRadius) * (d.data.numEntries / (maxValue+1)) + innerRadius;
        });

    let colorShift = d3.interpolateRgb("#54bace", "#26265E");
    return pie.map((d, index) => {
        let curColor = colorShift(index / (pie.length == 1?1:(pie.length - 1)));
        return (    
            <path data-multiline="true" data-html="true" data-tip={`${d.data.message? `${d.data.name}<p>${d.data.message}: ${d.data.numEntries}</p>`: `${d.data.name}: ${d.data.numEntries}`}`} data-for='item' key={index} d={arc(d)} fill={curColor} className="solidArc" stroke="gray"/>
           );
    });
};


const OuterPath = props => {
    let { pie, radius, innerRadius } = props;

    let arc = d3.arc()
        .innerRadius(innerRadius)
        .outerRadius(radius);

    return pie.map((d, index) => {
        return (  
            <path key={index} d={arc(d)} fill="none" className="outlineArc" stroke="gray"/>
           );
    });
};



export class AsterPlot extends React.Component {

    render() {

        let {chartData, width, height} = this.props;
        if(chartData.length === 0 ){
           return null;
        }

        let radius = Math.min(width, height) / 2,
            innerRadius = 0.3 * radius;

        let pie = d3.pie().value(function (d) {
            return 1;
        });

        let maxValue = Math.max.apply(Math, chartData.map(function(cur) { return cur.numEntries; }))
        let total = (chartData.reduce((acc,cur) => {
            return cur.numEntries + acc;
        }, 0));

        return (
            <div>
                <svg height={height} width={width}>
                    <g transform={`translate(${width / 2},${height / 2})`}>
                        <InnerPath pie={pie(chartData)} maxValue={maxValue} width={width} height={height} radius={radius} innerRadius={innerRadius} />
                        <OuterPath pie={pie(chartData)} width={width} height={height} radius={radius} innerRadius={innerRadius} />
                        <text dy={`.35em`} textAnchor="middle" style={{ 'fontSize': `${625 / (total.toString().length == 0 ? 1 : total.toString().length)}%` }} className="aster-score">{total}</text>
                    </g>
                </svg>
                <ReactTooltip id='item' />
            </div>

        );
    }

};
